import { csvConfigExport } from './export';
import { formatMoneyExport } from './number-helper';
import { PsrRecordType } from '@nxsys/types/models/revenueFilings/psr';
import moment from 'moment';
import { ExportToCsv } from 'export-to-csv';

export const onExportPSRData = (
  data: PsrRecordType[] = [],
  currencySymbol = '£',
  filename?: string,
) => {
  console.log("🚀 ~ onExportPSRData ~ filename:", filename)
  if (!data || data?.length === 0) {
    return;
  }
  const dataExport = data?.map((item) => {
    const { payload, submissionID } = item;
    const { payslips } = payload;
    const payslip = payslips?.[0];
    return {
      submissionID: submissionID,
      employeePpsn: payslip?.employeeID?.employeePpsn || '',
      employmentID: payslip?.employeeID?.employmentID || '',
      lineItemID: payslip?.lineItemID,
      firstName: payslip?.name?.firstName,
      familyName: payslip?.name?.familyName,
      payPeriod: payslip?.payPeriod,
      payFrequency: payslip?.payFrequency,
      taxCredits: formatMoneyExport(payslip?.taxCredits, currencySymbol, true),
      taxRates: payslip?.taxRates
        ?.map(
          (r) =>
            `index: ${r.index}, taxRatePercent: ${r.taxRatePercent}, yearlyRateCutOff: ${(r as any).yearlyRateCutOff || ''
            }, rateCutOff: ${r.rateCutOff || ''}`,
        )
        ?.join('\n'),
      incomeTaxCalculationBasis: payslip?.incomeTaxCalculationBasis,
      exclusionOrder: payslip?.exclusionOrder,
      payDate: payslip?.payDate
        ? moment(payslip?.payDate).tz('Europe/London').format('DD/MM/YYYY')
        : '',
      grossPay: formatMoneyExport(payslip?.grossPay, currencySymbol, true),
      payForIncomeTax: formatMoneyExport(
        payslip?.payForIncomeTax,
        currencySymbol,
        true,
      ),
      incomeTaxPaid: formatMoneyExport(
        payslip?.incomeTaxPaid,
        currencySymbol,
        true,
      ),
      payForEmployeePRSI: formatMoneyExport(
        payslip?.payForEmployeePRSI,
        currencySymbol,
        true,
      ),
      payForEmployerPRSI: formatMoneyExport(
        payslip?.payForEmployerPRSI,
        currencySymbol,
        true,
      ),
      prsiExempt: payslip?.prsiExempt,
      prsiClassDetails: payslip?.prsiClassDetails
        ?.map(
          (r) =>
            `prsiClass: ${r.prsiClass}, insurableWeeks: ${r.insurableWeeks}`,
        )
        ?.join('\n'),
      employeePRSIPaid: formatMoneyExport(
        payslip?.employeePRSIPaid,
        currencySymbol,
        true,
      ),
      employerPRSIPaid: formatMoneyExport(
        payslip?.employerPRSIPaid,
        currencySymbol,
        true,
      ),
      payForUSC: formatMoneyExport(payslip?.payForUSC, currencySymbol, true),
      uscStatus: payslip?.uscStatus,
      uscPaid: formatMoneyExport(payslip?.uscPaid, currencySymbol, true),
      lptDeducted: formatMoneyExport(
        payslip?.lptDeducted,
        currencySymbol,
        true,
      ),
      grossMedicalInsurance: formatMoneyExport(
        payslip?.grossMedicalInsurance,
        currencySymbol,
        true,
      ),
      shareBasedRemuneration: formatMoneyExport(
        payslip?.shareBasedRemuneration,
        currencySymbol,
        true,
      ),
      taxableBenefits: formatMoneyExport(
        payslip?.taxableBenefits,
        currencySymbol,
        true,
      ),
      taxableLumpSum: formatMoneyExport(
        payslip?.taxableLumpSum,
        currencySymbol,
        true,
      ),
      nonTaxableLumpSum: formatMoneyExport(
        payslip?.nonTaxableLumpSum,
        currencySymbol,
        true,
      ),
      employerRBS: formatMoneyExport(
        payslip?.employerRBS,
        currencySymbol,
        true,
      ),
      employeeRBS: formatMoneyExport(
        payslip?.employeeRBS,
        currencySymbol,
        true,
      ),
      employerPRSA: formatMoneyExport(
        payslip?.employerPRSA,
        currencySymbol,
        true,
      ),
      employeePRSA: formatMoneyExport(
        payslip?.employeePRSA,
        currencySymbol,
        true,
      ),
      employeeRAC: formatMoneyExport(
        payslip?.employeeRAC,
        currencySymbol,
        true,
      ),
      employeeAVC: formatMoneyExport(
        payslip?.employeeAVC,
        currencySymbol,
        true,
      ),
      employerPEPP: formatMoneyExport(
        payslip?.employerPEPP,
        currencySymbol,
        true,
      ),
      employeePEPP: formatMoneyExport(
        payslip?.employeePEPP,
        currencySymbol,
        true,
      ),
    };
  });

  const headersExport = [
    'submissionID',
    'employeePpsn',
    'employmentID',
    'lineItemID',
    'firstName',
    'familyName',
    'payPeriod',
    'payFrequency',
    'taxCredits',
    'taxRates',
    'incomeTaxCalculationBasis',
    'exclusionOrder',
    'payDate',
    'grossPay',
    'payForIncomeTax',
    'incomeTaxPaid',
    'payForEmployeePRSI',
    'payForEmployerPRSI',
    'prsiExempt',
    'prsiClassDetails',
    'employeePRSIPaid',
    'employerPRSIPaid',
    'payForUSC',
    'uscStatus',
    'uscPaid',
    'lptDeducted',
    'grossMedicalInsurance',
    'shareBasedRemuneration',
    'taxableBenefits',
    'taxableLumpSum',
    'nonTaxableLumpSum',
    'employerRBS',
    'employeeRBS',
    'employerPRSA',
    'employeePRSA',
    'employeeRAC',
    'employeeAVC',
    'employerPEPP',
    'employeePEPP',
  ];

  const finalFilename = filename || (data.length === 1 ? `PSR-Requests-Export-${data[0]?.subcontractor?.id}-${data[0]?.subcontractor?.fullName}` : 'PSR-Requests-Export');
  const exportName = csvConfigExport(finalFilename, headersExport);
  const csvExporter = new ExportToCsv(exportName);
  csvExporter.generateCsv(dataExport);
};

export const onExportPSRError = (data: PsrRecordType[] = [], filename?: string) => {
  const dataExport = data?.map((item) => {
    const { response, submissionID, company, subcontractor } = item;

    if (typeof response === 'string') {
      return {
        submissionID: submissionID,
        companyID: company?.id || '',
        subcontractorID: subcontractor?.id || '',
        description: response,
        code: '',
        path: '',
      };
    }
    const { validationErrors } = response;

    const descriptions =
      validationErrors?.map((r) => r?.description || '').join('\n') || '';
    const codes = validationErrors?.map((r) => r?.code || '').join('\n') || '';
    const paths = validationErrors?.map((r) => r?.path || '').join('\n') || '';

    return {
      submissionID: submissionID,
      companyID: company?.id || '',
      subcontractorID: subcontractor?.id || '',
      description: descriptions,
      code: codes,
      path: paths,
    };
  });
  const headersExport = [
    'submissionID',
    'Employer ID',
    'Employee ID',
    'Description',
    'Code',
    'Path',
  ];
  const finalFilename = filename || (data.length === 1 ? `PSR-Errors-Export-${data[0]?.subcontractor?.id}-${data[0]?.subcontractor?.fullName}` : 'PSR-Errors-Export');
  const exportName = csvConfigExport(finalFilename, headersExport);
  const csvExporter = new ExportToCsv(exportName);
  csvExporter.generateCsv(dataExport);
};

export const handleDownloadJson = (
  jsonData: any,
  type: 'request' | 'response',
) => {
  const element = document.createElement('a');
  const jsonFile = JSON.stringify(jsonData);
  const file = new Blob([jsonFile], { type: 'text/json' });
  element.href = URL.createObjectURL(file);
  element.download = type === 'request' ? 'request.json' : 'response.json';
  document.body.appendChild(element);
  element.click();
};

export const handleExportPSRPayroll = (
  data: PsrRecordType[],
  currencySymbol: string,
) => {
  const dataExport = data?.map((item) => {
    const { payroll, subcontractor, company } = item;
    const {
      irelandValue,
      id,
      otherPayment,
      paymentDate,
      taxPeriod,
      taxYear,
      selfBillRef,
      payFrequency,
      timesheetValue,
      payeeUmbrellaValue,
      otherDeduction,
      net,
    } = payroll;

    return {
      companyID: company?.id || '',
      subcontractorID: subcontractor?.agencyRef || '',
      foreNames: subcontractor?.forename || '',
      surebname: subcontractor?.surname || '',
      taxPeriod: taxPeriod || '',
      taxYear: taxYear || selfBillRef?.taxYear || '',
      payFrequency: payFrequency,
      paymentCompany: company?.companyName || '',
      grossPay: formatMoneyExport(timesheetValue, currencySymbol),
      units: payeeUmbrellaValue?.totalHours || 0,
      salary: formatMoneyExport(irelandValue?.salary || 0, currencySymbol),
      notionalPay: formatMoneyExport(
        irelandValue?.notionalPay || 0,
        currencySymbol,
      ),
      taxableGross: formatMoneyExport(
        irelandValue?.taxGross || 0,
        currencySymbol,
      ),
      taxDeducted: formatMoneyExport(irelandValue?.tax || 0, currencySymbol),
      USCableGross: formatMoneyExport(
        irelandValue.uscGross || 0,
        currencySymbol,
      ),
      USC: formatMoneyExport(irelandValue?.usc || 0, currencySymbol),
      employeePRSIableGross: formatMoneyExport(
        irelandValue?.eePrsiGross || 0,
        currencySymbol,
      ),
      employeePRSI: formatMoneyExport(
        irelandValue?.eePRSI || 0,
        currencySymbol,
      ),
      employerPRSIableGross: formatMoneyExport(
        irelandValue?.erPrsiGross || 0,
        currencySymbol,
      ),
      employerPRSI: formatMoneyExport(
        irelandValue?.erPRSI || 0,
        currencySymbol,
      ),
      pensionableGross: formatMoneyExport(
        irelandValue?.pensionGross || 0,
        currencySymbol,
      ),
      employeePension: formatMoneyExport(
        irelandValue?.eePension,
        currencySymbol,
      ),
      employerPension: formatMoneyExport(
        irelandValue?.erPension,
        currencySymbol,
      ),
      LPT: formatMoneyExport(irelandValue?.lptDeducted || 0, currencySymbol),
      netPay: formatMoneyExport(net, currencySymbol),
      otherPayment: formatMoneyExport(otherPayment, currencySymbol),
      otherDeduction: formatMoneyExport(otherDeduction, currencySymbol),
      sickPay: formatMoneyExport(payeeUmbrellaValue?.ssp, currencySymbol),
      paymentDate: paymentDate
        ? moment(paymentDate).tz('Europe/London').format('DD/MM/YYYY')
        : '',
      department: subcontractor?.department || '',
      payslipID: id,
    };
  });
  const headersExport = [
    'Employer ID',
    'Employee ID',
    'Forenames',
    'Surname',
    'Tax Period',
    'Tax Year',
    'Pay Frequency',
    'Employer',
    'Gross Pay',
    'Units',
    'Salary',
    'Notional Pay',
    'Taxable Gross',
    'Tax Deducted',
    'USCable Gross',
    'USC',
    'Employee PRSIable Gross',
    'Employee PRSI',
    'Employer PRSIable Gross',
    'Employer PRSI',
    'Pensionable Gross',
    'Employee Pension',
    'Employer Pension',
    'LPT',
    'Net Pay',
    'Other Payment',
    'Other Deduction',
    'Sick Pay (SSP)',
    'Payment Date',
    'Department',
    'Payslip ID',
  ];
  const exportName = csvConfigExport(`PSR-payroll-EXPORT`, headersExport);
  const csvExporter = new ExportToCsv(exportName);
  csvExporter.generateCsv(dataExport);
};

export const calcInsurable = (value: string) => {
  switch (value) {
    case 'WEEKLY':
      return 1;
    case '2_WEEKLY':
      return 2;
    case '4_WEEKLY':
      return 4;
    case 'MONTHLY':
      return 4;
    default:
      return 1;
  }
};